goog.provide('el8.ptdata.historyItems');

// TODO JSCLEAN Need to add goog.require's everywhere for el8.ptdata.historyItems

goog.require('el8.model.base');
goog.require('el8.ptdata.model.PatientItemSet');
goog.require('el8.util.consts');

(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makePatientItem();

    _class.addStringProperty('text', true);
    _class.addStringProperty('type', true);
    _class.addIntProperty('rank');

    _class.prototype.populate = function(spec) {
        spec = spec || {};
        if (spec.type) { spec.type = spec.type.capitalize(); }
        spec.model_class = 'PatientHistoryItem';
        this.parent.populate.call(this, spec);
    };

    /**
     *  HELPER METHODS
     */
    _class.prototype.getNoteSummary = function() {
        if (this.getType() === 'Functional') {
            return 'Func status: ' + this.getText();
        }
        if (this.getType() === 'Cognitive') {
            return 'Cogn status: ' + this.getText();
        }
        return this.getText();
    };

    /**
     * Generate global dataset for each type in HISTORY_ITEM_TYPES
     */
    el8.util.consts.HISTORY_ITEM_TYPES.map(function(type) {

        el8.ptdata.historyItems[type] = new el8.ptdata.model.PatientItemSet({
            model: (function(_type) {
                return function(spec) {
                    spec.type = _type;
                    return new _class(spec);
                };
            })(type),

            sortFn: function(a, b){ return a.getRank()-b.getRank(); },

            saveFn: function(item, successCallbackFn, errorCallbackFn, opts) {
                
                var saved = false;
                $.el8_ajax({
                    type: 'POST',
                    async: opts ? (opts.async !== false) : true,  // defaults to true
                    url: el8.service.urls.get('historyItems', [item]),
                    data: JSON.stringify(item.asMap()),
                    success: function(data) {
                        saved = true;
                        var _type = item.getType().toLowerCase();
                        if (item.getId()) {
                            el8.ptdata.historyItems[_type].updateItemId(item, data.item.id);
                        } else {
                            item.setId(data.item.id);
                        }
                        el8.appservice.notifier.notify(item.getType() + ' history item saved.');
                        if( successCallbackFn ) { successCallbackFn(item); }
                    }
                });
                return saved ? item : null;
            },

            deleteFn: function(item, successCallbackFn) {
                $.el8_ajax({
                    type: 'DELETE',
                    url: el8.service.urls.get('historyItems', [item]),
                    success: successCallbackFn
                });
            }
        });
    });

})();

el8.ptdata.historyItems.getAll = function() {
    var result = [];
    el8.util.consts.HISTORY_ITEM_TYPES.map(function(type) {
        result.addArray(el8.ptdata.historyItems[type].all());
    });
    return result;
};

/* Each history type has its own entity set, but this will (re)load
 * them all at once */
el8.ptdata.historyItems.loadAll = function(opts) {
    opts = opts || {};
    return $.el8_ajax({
        type: 'GET',
        url: el8.service.urls.get('historyItems'),
        success: function(data) {
            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    el8.ptdata.historyItems[key].create(data[key]);
                }
            }
            if (opts.success) { opts.success(data); }
        },
        error: opts.error
    });
};

/* Emulates the standard entitySet.create by finding the appropriate
 * entity set for a given history type */
el8.ptdata.historyItems.create = function(data, noNotify) {
    if (data instanceof Array) {
        var created = data.map(function(singleItem) {
            return el8.ptdata.historyItems.create(singleItem, noNotify);
        });
        return created;
    } else {
        var historyEntitySet = el8.ptdata.historyItems[data.type.toLowerCase()];
        return historyEntitySet.create(data, noNotify);
    }
};

